// Classifies a multi-SKU Add-to-Cart (GIS ATB) response into one of three
// outcomes so AddAllButton can route to FER-797 (full success),
// FER-755 (partial failure) or FER-798 (total failure).
//
// The Cart API returns item-level failures on the `errors` map keyed by skuId.
// A rejected promise (Cart API error) is handled by the caller, not here.

const ATB_RESULT = {
    SUCCESS: 'SUCCESS',
    PARTIAL: 'PARTIAL',
    ERROR: 'ERROR'
};

/**
 * @param {string[]} requestedSkuIds - SKU ids submitted in the ATB request.
 * @param {object} response - Cart API basket response.
 * @returns {'SUCCESS'|'PARTIAL'|'ERROR'}
 */
function classifyAtbResult(requestedSkuIds = [], response = {}) {
    const errors = response?.errors || {};
    const failedSkuIds = requestedSkuIds.filter(skuId => Boolean(errors[skuId]));
    const addedCount = requestedSkuIds.length - failedSkuIds.length;

    if (addedCount <= 0) {
        return ATB_RESULT.ERROR;
    }

    if (failedSkuIds.length > 0) {
        return ATB_RESULT.PARTIAL;
    }

    return ATB_RESULT.SUCCESS;
}

export { ATB_RESULT };

export default classifyAtbResult;
